<template>
    <div class="container">
      <div id="projects" class="section mb-5">
        <div class="section-title">
          Projects
        </div>
      </div>
      <div>
        <h6 class="mb-3 section-sub-title">APPLICATIONS</h6>
        <div class="mb-5" v-for="project, index in data" :key="index">
          <div class="project-card">
            <div class="project-card-header">
                <div>
                    <p class="project-title">{{project.Title}}</p>
                </div>
                <div>
                    <a :href="project.Link" target="_blank" rel="noopener noreferrer" class="mr-2">
                        Link
                    </a>
                    <a :href="project.Repo" target="_blank" rel="noopener noreferrer">
                        Repo
                    </a>
                </div>
            </div>
            <div class="project-card-content">
                <div class="project-card-content-upper">
                    <p>{{project.Description}}</p>
                </div>
                <div class="project-card-content-lower">
                    <a  v-for="tech, index in project.Tech" :key="index">{{tech}}</a>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import {porfolioData} from '../service/index'
export default {
  name: 'Projects', 
  data(){
    return{
        data: []
    }
  },
  beforeMount(){
      porfolioData()
      .then(response => {
          this.data = response.Project
          
      })
  }
}
</script>